var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSizeGuide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E2CBF635-8E6B-4D68-8349-15F688BC49C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-PDP",
    transform: "translate(-1168.000000, -450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-info",
    transform: "translate(992.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCCCCC",
    x: 0.5,
    y: 0.5,
    width: 591,
    height: 519,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Size",
    transform: "translate(24.000000, 186.000000)",
    fill: "#EA6797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plus",
    transform: "translate(152.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.906,6 C18.511,6 19,6.489 19,7.094 L19,7.094 L19,12.906 C19,13.51 18.511,14 17.906,14 L17.906,14 L3.094,14 C2.49,14 2,13.51 2,12.906 L2,12.906 L2,7.094 C2,6.489 2.49,6 3.094,6 L3.094,6 Z M4,7 L3.094,7 C3.042,7 3,7.042 3,7.094 L3,7.094 L3,12.906 C3,12.958 3.042,13 3.094,13 L3.094,13 L17.906,13 C17.958,13 18,12.958 18,12.906 L18,12.906 L18,7.094 C18,7.042 17.958,7 17.906,7 L17.906,7 L17,7 L17,9.531 C17,9.79 16.776,10 16.5,10 C16.23,10 16.01,9.8 16,9.549 L16,9.549 L16,7 L15,7 L15,8.531 C15,8.79 14.776,9 14.5,9 C14.23,9 14.01,8.8 14,8.549 L14,8.549 L14,7 L13,7 L13,9.531 C13,9.79 12.776,10 12.5,10 C12.23,10 12.01,9.8 12,9.549 L12,9.549 L12,7 L11,7 L11,8.531 C11,8.79 10.776,9 10.5,9 C10.23,9 10.01,8.8 10,8.549 L10,8.549 L10,7 L9,7 L9,9.531 C9,9.79 8.776,10 8.5,10 C8.23,10 8.01,9.8 8,9.549 L8,9.549 L8,7 L7,7 L7,8.531 C7,8.79 6.776,9 6.5,9 C6.23,9 6.01,8.8 6,8.549 L6,8.549 L6,7 L5,7 L5,9.531 C5,9.79 4.776,10 4.5,10 C4.23,10 4.01,9.8 4,9.549 L4,9.549 L4,7 Z",
    id: "Combined-Shape"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeGuide);
export default __webpack_public_path__ + "static/media/size-guide.cc45949e.svg";
export { ForwardRef as ReactComponent };